import { AndroidAdaptiveBitrateStrategy } from '@sky-uk-ott/client-lib-js-device';
// Internal Config
// Client Config when Remote Config is disabled
export function adaptAndroidTvClientConfig() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _config_defaultConfig = config.defaultConfig, defaultConfig = _config_defaultConfig === void 0 ? {} : _config_defaultConfig, _config_clientConfig = config.clientConfig, clientConfig = _config_clientConfig === void 0 ? {} : _config_clientConfig;
    return {
        eac3: defaultConfig.eac3 || false,
        adaptiveBitrateStrategy: clientConfig.adaptiveBitrateStrategy || AndroidAdaptiveBitrateStrategy.DEFAULT,
        maxBitrate: defaultConfig.maxBitrate,
        exclude4kTrack: defaultConfig.exclude4kTrack,
        maxResolution: defaultConfig.maxResolution
    };
}
// Server Config when Remote Config is enabled
// Client Config when Remote Config is enabled
export function adaptAndroidTvRemoteConfigSplit(config) {
    var _config_remoteConfig = config.remoteConfig, remoteConfig = _config_remoteConfig === void 0 ? {} : _config_remoteConfig;
    return {
        eac3: remoteConfig.eac3,
        adaptiveBitrateStrategy: remoteConfig.adaptiveBitrateStrategy || AndroidAdaptiveBitrateStrategy.DEFAULT,
        maxBitrate: remoteConfig.maxBitrate,
        exclude4kTrack: remoteConfig.exclude4kTrack,
        maxResolution: remoteConfig.maxResolution
    };
}

//# sourceMappingURL=android-tv-config-adapter.js.map